import validate from "/builds/rialtic/workflows/console-ui/node_modules/.pnpm/nuxt@3.17.7_577197986abc90e918ecb96bc892a90c/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45required_45global from "/builds/rialtic/workflows/console-ui/packages/nuxt-auth0/src/runtime/middleware/auth-required.global.ts";
import _02_45route_45rules_45global from "/builds/rialtic/workflows/console-ui/apps/console/middleware/02.route-rules.global.ts";
import _03_45rbac_45global from "/builds/rialtic/workflows/console-ui/apps/console/middleware/03.rbac.global.ts";
import _04_45sanitize_45query_45params_45global from "/builds/rialtic/workflows/console-ui/apps/console/middleware/04.sanitize-query-params.global.ts";
import feature_45flags_45global from "/builds/rialtic/workflows/console-ui/apps/console/middleware/feature-flags.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45required_45global,
  _02_45route_45rules_45global,
  _03_45rbac_45global,
  _04_45sanitize_45query_45params_45global,
  feature_45flags_45global
]
export const namedMiddleware = {
  "claim-lab": () => import("/builds/rialtic/workflows/console-ui/apps/claim-lab/middleware/claim-lab.ts"),
  "all-connectors": () => import("/builds/rialtic/workflows/console-ui/apps/console/middleware/all-connectors.ts"),
  "connector-required": () => import("/builds/rialtic/workflows/console-ui/apps/console/middleware/connector-required.ts"),
  "policy-context-required": () => import("/builds/rialtic/workflows/console-ui/apps/console/middleware/policy-context-required.ts"),
  "rialtic-admin": () => import("/builds/rialtic/workflows/console-ui/apps/console/middleware/rialtic-admin.ts"),
  "workspace-system-admin": () => import("/builds/rialtic/workflows/console-ui/apps/console/middleware/workspace-system-admin.ts")
}